/**
 * Replace curly brackets in window.MASK_PHRASES with value from config object
 * @param str - input string
 * @param obj - config object
 * @returns {String} - localized string
 */
export function supplant(str, obj) {
    return str.replace(/{([^{}]*)}/g, (a, b) => {
        const r = obj[b];
        return typeof r === 'string' || typeof r === 'number' ? r : a;
    });
}
